import { render, staticRenderFns } from "./CreativeTestsIcon.vue?vue&type=template&id=b61ceb96"
import script from "./CreativeTestsIcon.vue?vue&type=script&lang=js"
export * from "./CreativeTestsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports